"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAvailableStartTimesForSelectedDate = exports.isSelectedDateAvailable = exports.getAvailableDates = exports.getGroupedAvailableTimes = exports.getAvailableStartTimes = exports.getAvailabilityForSelectedDuration = exports.getLinkAvailabilityByDuration = void 0;

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _reselect = require("reselect");

var _BookInfoSelectors = require("MeetingsLib/selectors/BookInfoSelectors");

var _RequestStatusSelectors = require("MeetingsLib/selectors/RequestStatusSelectors");

var getLinkAvailabilityByDuration = (0, _reselect.createSelector)([_RequestStatusSelectors.getIsFetchingPublicAvailability, _RequestStatusSelectors.availabilityFetchFailed, _BookInfoSelectors.getBookInfo], function (isFetchingPublicAvailability, availabilityFetchFailed, bookInfo) {
  var availabilityByDuration = bookInfo.getIn(['linkAvailability', 'linkAvailabilityByDuration']);

  if (isFetchingPublicAvailability || availabilityFetchFailed || !availabilityByDuration) {
    return (0, _immutable.List)();
  }

  return availabilityByDuration;
});
exports.getLinkAvailabilityByDuration = getLinkAvailabilityByDuration;
var getAvailabilityForSelectedDuration = (0, _reselect.createSelector)([_RequestStatusSelectors.getIsFetchingPublicAvailability, _RequestStatusSelectors.availabilityFetchFailed, getLinkAvailabilityByDuration, _BookInfoSelectors.getMeetingLength], function (isFetchingPublicAvailability, availabilityFetchFailed, linkAvailabilityByDuration, duration) {
  if (isFetchingPublicAvailability || availabilityFetchFailed || !linkAvailabilityByDuration.size) {
    return (0, _immutable.List)();
  }

  return linkAvailabilityByDuration.find(function (availabilityByDuration) {
    return availabilityByDuration.get('meetingDurationMillis') === duration;
  }).get('availabilities');
});
exports.getAvailabilityForSelectedDuration = getAvailabilityForSelectedDuration;
var getAvailableStartTimes = (0, _reselect.createSelector)([_BookInfoSelectors.getIsUngatedForLinkAvailability, getAvailabilityForSelectedDuration, _BookInfoSelectors.getAvailableStartTimes], function (isUngatedForLinkAvailability, availabilities, DEPRECATED_availableStartTimes) {
  return isUngatedForLinkAvailability ? availabilities.map(function (availability) {
    return availability.get('startMillisUtc');
  }) : DEPRECATED_availableStartTimes;
});
exports.getAvailableStartTimes = getAvailableStartTimes;
var getGroupedAvailableTimes = (0, _reselect.createSelector)([getAvailableStartTimes, _BookInfoSelectors.getUserTimezone], function (startTimes, userTimezone) {
  return startTimes.groupBy(function (startMillisUtc) {
    return _I18n.default.moment(startMillisUtc).tz(userTimezone).format('YYYY-MM-DD');
  });
});
exports.getGroupedAvailableTimes = getGroupedAvailableTimes;
var getAvailableDates = (0, _reselect.createSelector)([getGroupedAvailableTimes], function (groupedAvailableTimes) {
  return groupedAvailableTimes.keySeq();
});
exports.getAvailableDates = getAvailableDates;
var isSelectedDateAvailable = (0, _reselect.createSelector)([getAvailableDates, _BookInfoSelectors.getEvent], function (availableDates, event) {
  return availableDates.includes(event.dateString);
});
exports.isSelectedDateAvailable = isSelectedDateAvailable;
var getAvailableStartTimesForSelectedDate = (0, _reselect.createSelector)([getGroupedAvailableTimes, _BookInfoSelectors.getEvent], function (groupedAvailableTimes, event) {
  return groupedAvailableTimes.get(event.dateString) || (0, _immutable.List)();
});
exports.getAvailableStartTimesForSelectedDate = getAvailableStartTimesForSelectedDate;